$ = require 'jquery'
TrelloEmoji = require('data/emoji').default
View = require 'view'
t = require('views/internal/recup-with-helpers')('reactions')
trackUe = require 'debug/trackUe'
_ = require 'underscore'
React = require 'react'
ReactDOM = require 'react-dom'
{ Picker } = require 'emoji-mart'
ReactRootComponent = require 'views/internal/react-root-component'

emojiMartLocalization = {
  search: t.l('search'),
  notfound: t.l('no-emoji-found'),
  categories: {
    search: t.l('categories-search-results'),
    recent: t.l('categories-frequently-used'),
    people: t.l('categories-smileys-and-people').replace(/&amp;/g, '&'), #escaped ampersands are not handled by emojimart
    nature: t.l('categories-animals-and-nature').replace(/&amp;/g, '&'),
    foods: t.l('categories-food-and-drink').replace(/&amp;/g, '&'),
    activity: t.l('categories-activity'),
    places: t.l('categories-travel-and-places').replace(/&amp;/g, '&'),
    objects: t.l('categories-objects'),
    symbols: t.l('categories-symbols'),
    flags: t.l('categories-flags'),
    custom: t.l('categories-custom')
  }
}

module.exports = class ReactionSelector extends View
  render: ->
    # render the picker within the popover we selected for it
    ReactDOM.render(@getEmojiPicker(), $('.mod-reaction-selector')[0])

    @

  trackWithData: (verb, dirObj, prepObj, indObj, method) ->
    actionData = JSON.stringify
      actionId: @options.actionId

    trackUe("Reactions", verb, dirObj, prepObj, indObj, method, actionData)

  handleReactionClick: (e, emoji) ->
    trackFn = (isAdded) =>
      method =
        'by picking a reaction'
      @trackWithData(
        if isAdded then 'adds' else 'removes',
        'reaction',
        emoji.id,
        if isAdded then 'to a comment' else 'from a comment',
        method,
      )

    @options.reactionList.toggleReaction(@options.actionId, emoji, trackFn)
    @options.onReactionClick && @options.onReactionClick(e, emoji)

  getEmojiPicker: ->
    t.render => t.div =>
      t.createElement Picker, {
        title: ''
        emoji: 'v'
        color: '#0079BF'
        set: 'twitter'
        i18n: emojiMartLocalization
        onClick: (emoji, e) => @handleReactionClick(e, emoji)
      }

  willBePopped: ->
    $('.js-open-reactions').removeClass 'active'



// WEBPACK FOOTER //
// ./app/scripts/views/reactions/reaction-selector.coffee